import React from "react";
import archImage from '../assets/images/technova-architecture.png';
import '../assets/styles/Project.scss'; // Reuse project styles or create new ones

function ProjectOverview() {
    return (
        <div className="projects-container" id="overview">
            <h1>Project Overview</h1>
            <div className="project-overview-content">
                <div className="overview-text">
                    <p>
                        <strong>Technova Solutions SISRH</strong> est un projet ambitieux visant à moderniser la gestion des ressources humaines via une plateforme ERP (Odoo 16) robuste, sécurisée et hautement disponible. 
                        L'objectif est de fournir une solution clé en main capable de s'adapter aux besoins croissants de l'entreprise tout en garantissant une excellence opérationnelle.
                    </p>
                    <p>
                        Ce projet repose sur une approche <strong>Infrastructure as Code (IaC)</strong> et des pratiques <strong>GitOps</strong> rigoureuses pour assurer la cohérence entre les environnements de développement et de production.
                    </p>
                </div>

                <div className="architecture-image-section">
                    <h2>Architecture Globale du Système</h2>
                    <img src={archImage} alt="Global Architecture" style={{ width: '100%', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.3)', margin: '20px 0' }} />
                    <p className="image-description">
                        L'architecture hybride combine la flexibilité d'un environnement de <strong>Dev/Staging sur VPS</strong> (géré par Ansible et Portainer avec une approche GitOps) et la puissance d'une <strong>Production sur AWS Cloud</strong>.
                    </p>
                </div>

                <div className="tech-stack-details">
                    <h3>Technologies Clés</h3>
                    <ul>
                        <li><strong>Orchestration & Conteneurs :</strong> Kubernetes (Amazon EKS) pour la prod, Docker Swarm/Compose pour le dev.</li>
                        <li><strong>Automatisation & IaC :</strong> Terraform pour le provisionnement AWS, Ansible pour la configuration des serveurs et le déploiement hybride.</li>
                        <li><strong>GitOps :</strong> ArgoCD pour la synchronisation continue sur Kubernetes, et Portainer pour la gestion GitOps de l'environnement de développement.</li>
                        <li><strong>Base de Données :</strong> Amazon RDS (PostgreSQL Multi-AZ) assurant haute disponibilité et sauvegardes automatiques.</li>
                        <li><strong>Sécurité :</strong> AWS WAF, Secrets Manager, et certificats SSL automatiques via Caddy.</li>
                        <li><strong>Observabilité :</strong> Stack complète Prometheus, Grafana et Loki pour le monitoring en temps réel et la centralisation des logs.</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default ProjectOverview;